<h2>New customer</h2>
<div>
  <mat-form-field class="name">
    <mat-label>Name</mat-label>
    <input matInput #input cdkFocusInitial />
  </mat-form-field>
</div>
<div class="buttons">
  <button mat-raised-button mat-dialog-close color="warn">Cancel</button>
  <button mat-raised-button [mat-dialog-close]="input.value" color="primary" [disabled]="!input.value">Save</button>
</div>
